import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import Esy from '../../../api/models/esy';
import { getEsys } from '../../../api/services/esyService';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';

type ViewState = {
    message?: string;
};

const ViewESYs = () => {
    const columns = React.useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
                width: 200,
            },
            {
                id: 'division',
                Header: 'Divisions',
                accessor: (d: any) => d.esyDivisions.length === 0 ? 'Global' : d.esyDivisions.sort((a: any, b: any) => (a.division.name.toLowerCase() > b.division.name.toLowerCase()) ? 1 : -1).map((d: any) => d.division.name).join(', '),
            },
            {
                accessor: 'esyId',
                disableSortBy: true,
                Cell: () => {
                    return (
                        <div className='clearfix'>
                            <span className='float-right'>
                                <PencilIcon className="w-5 h-5 cursor-pointer" aria-hidden="true" />
                            </span>
                        </div>
                    );
                },
                wdith: 50,
                className: "hidden sm:table-cell"
            },
        ],
        []
    );

    const history = useHistory();
    const { state } = useLocation<ViewState>();
    const [ESYs, setESYs] = useState<Esy[]>([]);

    const { error, isPending } = useAsync({
        promiseFn: getEsys,
        onResolve: (r) => {
            setESYs(r.data.esys);
        },
    });

    if (error) return <LayoutError />;

    return (
        <Layout isLoading={isPending}>
            <Fragment>
                {state?.message && <Notification message={state?.message} />}
                <div className='mb-4 text-right'>
                    <Link className='btn' to='/admin/esys/new'>
                        Add ESY
                    </Link>
                </div>

                <DataTable
                    columns={columns}
                    data={ESYs}
                    showPagination={true}
                    getRowProps={(row: any) => ({
                        onClick: () => history.push(`/admin/esys/${row.values.esyId}`),
                        className: "cursor-pointer hover:bg-gray-100",
                    })}
                />
            </Fragment>
        </Layout>
    );
};

export default ViewESYs;
